import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const GuiaPasaporteModal = () => {
  const [mostrar, setMostrar] = useState(false);

  const abrirModal = () => setMostrar(true);
  const cerrarModal = () => setMostrar(false);

  return (
    <>
      <button
        type="button"
        className="btn btn-sm badge badge-pill bg-primary text-white border-0 ml-2"
        onClick={abrirModal}
      >
        Ver guía para subir el pasaporte
      </button>

      <Modal show={mostrar} onHide={cerrarModal} centered large>
        <Modal.Header closeButton className="bg-light">
          <Modal.Title className="font-weight-bold">
            Guía para subir el pasaporte
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <ul className="list-unstyled mb-0">
            <li>
              <i className="fas fa-file-alt fa-fw text-primary mr-2"></i>{" "}
              <strong>Formatos aceptados:</strong> PDF, PNG, JPG, JPEG, TIFF,
              TIF o BMP.
            </li>
            <li>
              <i className="fas fa-exclamation-triangle fa-fw text-warning mr-2"></i>{" "}
              <strong>Tamaño máximo:</strong> el archivo no debe superar los 3
              MB.
            </li>
            <li>
              <i className="fas fa-search fa-fw text-secondary mr-2"></i>{" "}
              <strong>Calidad:</strong> la imagen debe ser legible, clara y de
              buena resolución.
            </li>
            <li>
              <i className="fas fa-ruler-horizontal fa-fw text-info mr-2"></i>{" "}
              <strong>Orientación:</strong> el texto debe estar horizontal y la
              imagen lo más recta posible.
            </li>
            <li>
              <i className="fas fa-lightbulb fa-fw text-warning mr-2"></i>{" "}
              <strong>Iluminación:</strong> evite sombras, reflejos o elementos
              que obstruyan el documento.
            </li>
            <li>
              <i className="fas fa-file-pdf fa-fw text-danger mr-2"></i>{" "}
              <strong>PDF:</strong> si sube un PDF, la imagen del pasaporte debe
              estar en la primera página.
            </li>
          </ul>
        </Modal.Body>

        <Modal.Footer className="bg-light">
          <Button variant="secondary" onClick={cerrarModal}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default GuiaPasaporteModal;
